import isHotkey from 'is-hotkey'

export function onEnter(event, callback) {
  console.log('on enter')

  if (isHotkey('enter', event)) {
    callback()
  }
}
